import { render, staticRenderFns } from "./liabilityPlan.vue?vue&type=template&id=3eedaf30&scoped=true"
import script from "./liabilityPlan.vue?vue&type=script&lang=js"
export * from "./liabilityPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eedaf30",
  null
  
)

export default component.exports